<template>
  <!-- <v-container
    :class="{ fullscreen: fullscreen }"
  >
    <v-row>
      <v-col cols="12">
        <v-card
          :flat="fullscreen"
        >
          <router-view />
        </v-card>
      </v-col>
    </v-row>
  </v-container> -->

  <div>
    <v-tabs
      :value="dashboardName"
      color="primary"
    >
      <v-tab
        v-for="tab in tabs"
        :to="{
          name: 'dashboard',
          params: {
            dashboardName: tab.key === 'default' ? undefined : tab.key,
          },
        }"
        exact="true"
        :key="tab.name"
      >
        {{ tab.name }}
      </v-tab>
    </v-tabs>

    <dashboard-component :config="config" />
  </div>
</template>

<script>
import dashboardConfig from "@/config/dashboardConfig";

import DashboardComponent from "@/ui/components/DashboardComponent.vue";

export default {
  components: {
    DashboardComponent,
  },
  props: {
    dashboardName: {
      type: String,
      default: "default",
    },
  },
  data() {
    return {
      // config: dashboardConfig(this),
    };
  },
  computed: {
    tabs() {
      return Object.entries(dashboardConfig(this)).reduce(
        (prev, [key, value]) => ({
          ...prev,
          [key]: {
            ...value,
            key,
          },
        }),
        {}
      );
    },
    config() {
      return (this.tabs[this.dashboardName] || { items: [] });
    },
    // fullscreen() {
    //   return this.$vuetify.breakpoint.xsOnly
    // },
  },
};
</script>

<style lang="scss" scoped>
.container.fullscreen {
  padding: 0;
}
</style>
